<!-- // ------------------------------------------ My Tasks -------------------------------------------->
<br>
<div class="hidden-xs filter-sidebar" [ngClass]="{'filter-sidebar-closed col-md-1' : !filterOpenState, 'col-md-3' : filterOpenState}">
	<div class="panel panel-default">
		<div class="panel-body">
			<div class="filter-body">
				<span class="lead"> {{LOCALIZATION.taskFilter}} </span>
				<hr>
				<form>
					<div class="bottom-spacing">
						<label for="filterField">{{LOCALIZATION.filterBy}}</label> 					
						<select id="filterField" name="filterField" class="form-control" [(ngModel)]="filter.active">
						  <option *ngFor="let filter of filters" [ngValue]="filter">{{ filter.label }}</option>
						</select>						
					</div>
					<div class="bottom-spacing">
						<div>
							<input id="filterValue" name="filterValue" class="form-control"
								placeholder="{{LOCALIZATION.workflowFilterPlaceholder}}"
								type="text" [(ngModel)]="filter.value"
								(keyup.enter)="applyFilter()" />
						</div>
						<div class="help-block">% - A wildcard for zero or more characters.</div>
					</div>
					<div>
                       <div class="primary-controls">
                           <button class="btn btn-default delete" (click)="clearFilter()">
                           		<span aria-hidden="true"></span> {{LOCALIZATION.clear}} 
                           </button>
                           <button class="btn btn-primary submit-button" (click)="applyFilter()">
                           		<span class="fas fa-filter" aria-hidden="true"></span> {{LOCALIZATION.filter}} 
                           </button>
                       </div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<div class="filter-sidebar"
	[ngClass]="{'col-xs-12 col-md-11' : !filterOpenState, 'col-xs-12 col-md-9' : filterOpenState}">
	<div class="dx-item-list-page">
		<div class="col-sm-12 col-md-12" style="margin-bottom: 74px;">
			<div class="clearfix">
				<div *ngIf="tasks && tasks.length > 0" class='pull-right primary-controls'>
					<button class="btn btn-primary btn-circle" (click)="loadMyTasks(1)"
						[disabled]="inprogress" title="{{LOCALIZATION.refresh}}">
						<i class="fas fa-sync"></i>
					</button>
					<button
						*ngIf="tasks && selectedTasks.selected > 0 && selectedTasks.canRelease"
						class="btn btn-circle btn-primary" title="Release tasks"
						(click)="onRelease()">
						<i class="fa fa-unlock" aria-hidden="true"></i>
					</button>
					<button
						*ngIf="tasks && selectedTasks.selected > 0 && selectedTasks.canAssign"
						class="btn btn-circle btn-primary" title="Reassign tasks"
						(click)="onAssign()">
						<i class="fa fa-share" aria-hidden="true"></i>
					</button>
					<button
						*ngIf="tasks && selectedTasks.selected > 0 && selectedTasks.canComplete"
						class="btn btn-circle btn-success" title="Complete tasks"
						(click)="onComplete()">
						<i class="fa fa-check" aria-hidden="true"></i>
					</button>
					<button
						*ngIf="tasks && selectedTasks.selected > 0 && selectedTasks.canReject"
						class="btn btn-circle btn-danger" title="Reject tasks"
						(click)="onReject()">
						<i class="fa fa-times-circle" aria-hidden="true"></i>
					</button>
				</div>
			</div>
			<table *ngIf="tasks && tasks.length > 0" class='table table-hover table-condensed dx-table'>
				<thead>
					<tr>
						<th class="dx-checkbox-col">
							<label style="display: inline;" class="control control--checkbox"> 
								<input
								aria-label="Select all" type="checkbox"
								[(ngModel)]="selectedTasks.all" (click)="toggleAllTasks()" />
								<div class="control__indicator"></div>
							</label>
						</th>
						<th class="pointMe sortable" (click)="sortingChanged('t.name')"
							title="{{LOCALIZATION.task}}">{{LOCALIZATION.task}}</th>
						<th class="pointMe sortable"
							(click)="sortingChanged('documentTitle')"
							title="{{LOCALIZATION.document}}">{{LOCALIZATION.document}}</th>
						<th class="pointMe sortable" (click)="sortingChanged('batchName')"
							title="{{LOCALIZATION.batch}}">{{LOCALIZATION.batch}}</th>		
						<th class="hidden-xs pointMe sortable"
							(click)="sortingChanged('state')"
							title="{{LOCALIZATION.taskStatus}}">{{LOCALIZATION.taskStatus}}</th>
						<th class="hidden-sm hidden-xs pointMe sortable"
							(click)="sortingChanged('priority')"
							title="{{LOCALIZATION.priority}}">{{LOCALIZATION.priority}}</th>
						<th class="hidden-sm hidden-xs" title="{{LOCALIZATION.dueDate}}">{{LOCALIZATION.dueDate}}</th>
						<!-- th class="hidden-sm hidden-xs">Last Opened</th  -->
						<th class="hidden-md hidden-sm hidden-xs pointMe sortable"
							(click)="sortingChanged('createdOn')"
							title="{{LOCALIZATION.createdDate}}">{{LOCALIZATION.createdDate}}</th>
						<th class="hidden-xs pointMe sortable"
							(click)="sortingChanged('documentPages')"
							title="{{LOCALIZATION.pages}}">{{LOCALIZATION.pages}}</th>
						<!-- th class="hidden-sm hidden-xs" title="{{LOCALIZATION.ocrScore}}">{{LOCALIZATION.ocrScore}}</th -->
						<th class="hidden-sm hidden-xs pointMe sortable"
							(click)="sortingChanged('workflowName')"
							title="{{LOCALIZATION.workflow}}">{{LOCALIZATION.workflow}}</th>
						<th class="text-center" style="width: 10%"
							title="{{LOCALIZATION.actions}}"><span class="hidden-xs">{{LOCALIZATION.actions}}</span></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor='let task of tasks'>
						<td>
							<label class="control control--checkbox"> <input
								[(ngModel)]="task.selected"
								(change)="toggleTaskId(task.taskId)" type="checkbox" />
								<div class="control__indicator"></div>
							</label>
						</td>
						<td class="truncate"><a title="Open this task"
							(click)="openTask(task)" class="pointMe">{{task.taskName}}</a></td>
						<td>
							<p title="{{task.productTitle}}"
								class='dd-text-collapse' 
								ddTextCollapse
								[ddTextCollapseMaxLength]="80" 
								[ddTextCollapseText]="task.productTitle">
							</p>								
						</td>
						<td><p class="truncate" title="{{task.batchName}}">{{task.batchName}}</p></td>
						<td class="hidden-xs">
							<p [ngClass]="{'alert-danger': task.state == 'OVERDUE'}" class="truncate" title="{{task.jbpmStatus}}">{{task.state}}</p>
						</td>
						<td class="hidden-sm hidden-xs">
							<p class="truncate" title="{{task.priority}}">{{task.priority}}</p>
						</td>
						<td class="hidden-sm hidden-xs">
							<p class="truncate" title="{{task.dueDateStr}}">{{task.dueDateStr || LOCALIZATION.none}}</p>
						</td>
						<!-- td class="hidden-sm hidden-xs"><p class="truncate" title="{{task.lastOpenedDateStr}}">{{task.lastOpenedDateStr}}</p></td  -->
						<td class="hidden-md hidden-sm hidden-xs">
							<p class="truncate" title="{{task.createdDateStr}}">{{task.createdDateStr}}</p>
						</td>
						<td class="hidden-xs">
							<p class="truncate" title="{{task.productPages}}">{{task.productPages}}</p>
						</td>
						<!-- td class="hidden-sm hidden-xs"><p class="truncate" title="{{task.productOCRScore}}">{{task.productOCRScore}}</p></td -->
						<td class="hidden-sm hidden-xs">
							<p class="truncate" title="{{task.workflowType}}">{{task.workflowType}}</p>
						</td>
						<td class="text-center">
			                    <div class="dropdown" id="workflow-operations-div" ngbDropdown>
								  <button ngbDropdownToggle
									  type="button"
									  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
									  aria-haspopup="true"
									  aria-expanded="false"
									  [attr.aria-label]="LOCALIZATION.actions"
									  title="{{LOCALIZATION.actions}}"
									  style="border: 0; background: transparent;">
										<i class="nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
								  </button>								  
			                      <ul class="dropdown-menu custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
									<li role="menuitem"><a (click)="showTaskProperties(task)"
										title="Show the task properties" class="pointMe menuitem">{{LOCALIZATION.properties}}</a></li>
									<li role="menuitem"><a (click)="showTaskLogs(task)"
										title="Show the task logs" class="pointMe menuitem">{{LOCALIZATION.logs}}</a></li>
									<li class="divider"></li>
									<li role="menuitem" *ngIf="task.actions.canRelease"><a
										(click)="onRelease(task.taskId)"
										title="Release this task to the unassigned task pool"
										class="pointMe menuitem-info">{{LOCALIZATION.release}}</a></li>
									<li role="menuitem" *ngIf="task.actions.canAssign"><a
										(click)="onAssign(task.taskId)" title="Reassign this task"
										class="pointMe menuitem-info">{{LOCALIZATION.reassign}}</a></li>
									<li class="divider"></li>
									<li role="menuitem" *ngIf="task.actions.canComplete"><a
										(click)="onComplete(task.taskId)" title="Complete this task"
										class="pointMe menuitem-success">{{LOCALIZATION.complete}}</a></li>
									<li role="menuitem" *ngIf="task.actions.canReject"><a
										(click)="onReject(task.taskId)" title="Reject this task"
										class="pointMe menuitem-danger">{{LOCALIZATION.reject}}</a></li>
								</ul>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div *ngIf="!inprogress && (!tasks || tasks.length == 0)">
				<i>{{LOCALIZATION.resultsEmpty}}</i>
			</div>
			<div *ngIf="inprogress">
				<i>{{LOCALIZATION.loading}}</i>
			</div>
		</div>
		<div class="tab-pagination-container">
			<div *ngIf="pagination && pagination.totalElements > 0" class="text-center">
				<div style="display: inline-flex; gap: 5px; align-items: center; margin-bottom: 10px;">
					<div *ngIf="tasks && tasks.length > 0" class="btn-group dropup hidden-xs" ngbDropdown>
						<button ngbDropdownToggle id="pageSizeButton" type="button"
							class="btn btn-primary submit-button submit-button-sm">
							{{LOCALIZATION.showing}} 
							<span class="badge" style="margin-right: 4px;">{{pagination.elementsPerPage}}</span><span class="caret"></span>
						</button>
						<ul ngbDropdownMenu class="dropdown-menu custom-drop" role="menu" aria-labelledby="pageSizeButton">
							<li role="menuitem" (click)="pageSizeChanged(10)"><a>10</a>
							</li>
							<li class="divider"></li>
							<li role="menuitem" (click)="pageSizeChanged(25)"><a>25</a>
							</li>
							<li class="divider"></li>
							<li role="menuitem" (click)="pageSizeChanged(50)"><a>50</a>
							</li>
						</ul>
					</div>
					<div class="hidden-xs current-page">{{pagination.pageGap}} - {{pagination.resultTotal}} {{LOCALIZATION.of}} {{pagination.totalElements}}</div>
					<ngb-pagination class="pagination custom-page pagination-sm"
						[(page)]="pagination.page" 
						[pageSize]="pagination.elementsPerPage"
						[collectionSize]="pagination.totalElements"
						(pageChange)="pagination.pageChanged($event)" 
						[maxSize]="5"
						[boundaryLinks]="true" 
						previousText="&#xf053;" 
						nextText="&#xf054;"
						firstText="&#xf053;&#xf053;" 
						lastText="&#xf054;&#xf054;">
					</ngb-pagination>
				</div>
			</div>
		</div>
	</div>
</div>
